import { render, staticRenderFns } from "./WorkPlaces.vue?vue&type=template&id=02186d15&scoped=true&"
import script from "./WorkPlaces.vue?vue&type=script&lang=js&"
export * from "./WorkPlaces.vue?vue&type=script&lang=js&"
import style0 from "./WorkPlaces.vue?vue&type=style&index=0&id=02186d15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02186d15",
  null
  
)

export default component.exports